import { BaseComponent } from 'components/BaseComponent';

export class BaseCellComp extends BaseComponent {
  toHelgaVehicle(helga_id) {
    window.open(
      `https://indewal.helga.eu/car/${helga_id}/edit#fndtn-advertise_panel`,
    );
  }
}
